module.exports = '<svg width="20" height="32" viewBox="0 0 20 32"><path d="M18 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h16c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6 29a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm4-5H4V6h12v18zM12 4H8V2h4v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/iphone-1.js
// module id = 1196
// module chunks = 14